import React from 'react'

import browser_bar from '../images/browser_bar.png'

function Mobile() {
  return (
    <div className="mobile">
      <p>
        请在<span style={{ color: '#0093FF' }}>电脑浏览器</span>中访问本页
      </p>
      <p style={{ color: '#0093FF' }}>5181688.com</p>
      <img src={browser_bar} alt="https://5181688.com" />
    </div>
  )
}

export default Mobile
